module.exports = __webpack_public_path__ + "img/file_management.9b9fd58a.svg";